(function () {
  'use strict';

  function initHeader(header) {
    if (!header || header.dataset.initialized === 'true') return;
    header.dataset.initialized = 'true';

    var megaTriggers = header.querySelectorAll('[data-mega-menu-trigger]');
    var megaPanels = header.querySelectorAll('[data-mega-menu-panels] > [data-mega-menu-label]');
    var megaPanelsContainer = header.querySelector('[data-mega-menu-panels]');
    var overlay = header.querySelector('[data-mega-menu-overlay]');
    var mobileToggle = header.querySelector('[data-mobile-menu-toggle]');
    var mobileClose = header.querySelector('[data-mobile-menu-close]');
    var mobileDrawer = header.querySelector('[data-mobile-drawer]');
    var cartToggles = header.querySelectorAll('[data-cart-toggle]');
    var searchToggles = header.querySelectorAll('[data-search-toggle]');
    var desktopSearchInput = header.querySelector('.oddit-header__search-input');

    var activeTrigger = null;
    var megaCloseTimer = null;
    var megaScrollLocked = false;

    function lockScroll() {
      if (megaScrollLocked) return;
      if (window.OdditScrollLock) window.OdditScrollLock.lock();
      else document.body.style.overflow = 'hidden';
      megaScrollLocked = true;
    }

    function unlockScroll() {
      if (!megaScrollLocked) return;
      if (window.OdditScrollLock) window.OdditScrollLock.unlock();
      else document.body.style.overflow = '';
      megaScrollLocked = false;
    }

    /* ------------------------------------------------------------
       Mega Menu — Open / Close
       ------------------------------------------------------------ */
    function openMegaPanel(label) {
      var matched = false;
      for (var i = 0; i < megaPanels.length; i++) {
        var panel = megaPanels[i];
        if (panel.getAttribute('data-mega-menu-label') === label) {
          panel.style.display = '';
          panel.setAttribute('aria-hidden', 'false');
          // Force reflow so transition applies
          void panel.offsetWidth;
          panel.classList.add('is-open');
          matched = true;
        } else {
          panel.classList.remove('is-open');
          panel.setAttribute('aria-hidden', 'true');
          panel.style.display = 'none';
        }
      }
      if (matched) {
        // The overlay lives inside the header's stacking context, so anchor it
        // just below the nav bar — otherwise it paints over the header's own
        // background in the side gutters. It still dims the page below and the
        // panel (higher z-index) stays above it.
        var headerBottom = Math.max(header.getBoundingClientRect().bottom, 0);
        if (overlay) {
          overlay.style.top = headerBottom + 'px';
          overlay.classList.add('is-visible');
        }
        // Cap the panel height to the space below the header so a tall menu
        // scrolls internally instead of forcing the page to scroll, and lock
        // the page scroll behind it.
        if (megaPanelsContainer) {
          megaPanelsContainer.style.setProperty(
            '--oddit-mega-max-height',
            window.innerHeight - headerBottom + 'px'
          );
        }
        lockScroll();
      }
    }

    function closeMegaMenu() {
      for (var i = 0; i < megaPanels.length; i++) {
        var panel = megaPanels[i];
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        panel.style.display = 'none';
      }
      for (var j = 0; j < megaTriggers.length; j++) {
        megaTriggers[j].setAttribute('aria-expanded', 'false');
      }
      activeTrigger = null;
      if (overlay) {
        overlay.classList.remove('is-visible');
      }
      unlockScroll();
    }

    function openMegaMenuFor(trigger) {
      if (megaCloseTimer) {
        clearTimeout(megaCloseTimer);
        megaCloseTimer = null;
      }
      var label = trigger.getAttribute('data-mega-menu-label');
      for (var j = 0; j < megaTriggers.length; j++) {
        megaTriggers[j].setAttribute('aria-expanded', 'false');
      }
      trigger.setAttribute('aria-expanded', 'true');
      activeTrigger = trigger;
      openMegaPanel(label);
    }

    function scheduleCloseMegaMenu() {
      if (megaCloseTimer) clearTimeout(megaCloseTimer);
      megaCloseTimer = setTimeout(function () {
        closeMegaMenu();
        megaCloseTimer = null;
      }, 180);
    }

    function isHoverPointer(e) {
      return e.pointerType === 'mouse' || e.pointerType === 'pen';
    }

    for (var t = 0; t < megaTriggers.length; t++) {
      (function (trigger) {
        var wrapper = trigger.closest('.oddit-header__link-wrapper') || trigger.parentElement;

        // Click handler — handles touch + keyboard activation
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            closeMegaMenu();
          } else {
            openMegaMenuFor(trigger);
          }
        });

        // Pointer events — hover open for mouse / pen only
        if (wrapper) {
          wrapper.addEventListener('pointerenter', function (e) {
            if (!isHoverPointer(e)) return;
            openMegaMenuFor(trigger);
          });
          wrapper.addEventListener('pointerleave', function (e) {
            if (!isHoverPointer(e)) return;
            scheduleCloseMegaMenu();
          });
        }
      })(megaTriggers[t]);
    }

    if (megaPanelsContainer) {
      megaPanelsContainer.addEventListener('pointerenter', function (e) {
        if (!isHoverPointer(e)) return;
        if (megaCloseTimer) {
          clearTimeout(megaCloseTimer);
          megaCloseTimer = null;
        }
      });
      megaPanelsContainer.addEventListener('pointerleave', function (e) {
        if (!isHoverPointer(e)) return;
        scheduleCloseMegaMenu();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', closeMegaMenu);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeMegaMenu();
        closeMobileDrawer();
      }
    });

    /* ------------------------------------------------------------
       Mobile Drawer
       ------------------------------------------------------------ */
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var mobileDrawerLastFocus = null;

    function visibleFocusables(root) {
      if (!root) return [];
      var nodes = root.querySelectorAll(FOCUSABLE);
      var visible = [];
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (!node.getClientRects().length) continue;
        if (window.getComputedStyle(node).visibility === 'hidden') continue;
        visible.push(node);
      }
      return visible;
    }

    function drawerFocusables() {
      return visibleFocusables(mobileDrawer);
    }

    function trapMobileDrawerFocus(e) {
      if (e.key !== 'Tab' || !mobileDrawer || !mobileDrawer.classList.contains('is-open')) return;
      var items = visibleFocusables(header);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function openMobileDrawer() {
      if (!mobileDrawer) return;
      mobileDrawerLastFocus = document.activeElement;
      // Anchor the drawer just below the header bar so the announcement bar and
      // header (with the close + search icons) stay visible above the menu.
      var headerBottom = Math.max(header.getBoundingClientRect().bottom, 0);
      mobileDrawer.style.setProperty('--oddit-mobile-drawer-top', headerBottom + 'px');
      mobileDrawer.classList.add('is-open');
      mobileDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (mobileToggle) {
        mobileToggle.setAttribute('aria-expanded', 'true');
        mobileToggle.setAttribute('aria-label', 'Close menu');
      }
      document.addEventListener('keydown', trapMobileDrawerFocus);
      var firstItem = drawerFocusables()[0];
      if (firstItem) firstItem.focus({ preventScroll: true });
    }

    function closeMobileDrawer() {
      if (!mobileDrawer) return;
      var wasOpen = mobileDrawer.classList.contains('is-open');
      mobileDrawer.classList.remove('is-open');
      mobileDrawer.setAttribute('aria-hidden', 'true');
      mobileDrawer.style.removeProperty('--oddit-mobile-drawer-top');
      document.body.style.overflow = '';
      if (mobileToggle) {
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileToggle.setAttribute('aria-label', 'Open menu');
      }
      document.removeEventListener('keydown', trapMobileDrawerFocus);
      if (wasOpen && mobileDrawerLastFocus && typeof mobileDrawerLastFocus.focus === 'function') {
        mobileDrawerLastFocus.focus({ preventScroll: true });
      }
      mobileDrawerLastFocus = null;
    }

    if (mobileToggle) {
      mobileToggle.addEventListener('click', function () {
        var isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeMobileDrawer();
        } else {
          // Close the search drawer first if it's open — otherwise the mobile
          // drawer technically opens but stays hidden beneath the search overlay.
          if (window.OdditSearchDrawer && window.OdditSearchDrawer.isOpen && window.OdditSearchDrawer.isOpen()) {
            window.OdditSearchDrawer.close();
          }
          openMobileDrawer();
        }
      });
    }
    if (mobileClose) {
      mobileClose.addEventListener('click', closeMobileDrawer);
    }

    /* ------------------------------------------------------------
       Mobile Submenu (mega-menu featured collections) accordion
       ------------------------------------------------------------ */
    var subnavToggles = header.querySelectorAll('[data-mobile-subnav-toggle]');
    for (var sn = 0; sn < subnavToggles.length; sn++) {
      subnavToggles[sn].addEventListener('click', function () {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        var panelId = this.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) {
          if (expanded) {
            panel.setAttribute('hidden', '');
          } else {
            panel.removeAttribute('hidden');
          }
        }
      });
    }

    /* ------------------------------------------------------------
       Cart Drawer Integration
       ------------------------------------------------------------ */
    for (var c = 0; c < cartToggles.length; c++) {
      cartToggles[c].addEventListener('click', function () {
        if (window.OdditCartDrawer) {
          window.OdditCartDrawer.open();
        }
      });
    }

    /* ------------------------------------------------------------
       Search Drawer Integration
       ------------------------------------------------------------ */
    for (var s = 0; s < searchToggles.length; s++) {
      searchToggles[s].addEventListener('click', function () {
        if (window.OdditSearchDrawer) {
          window.OdditSearchDrawer.open();
        }
      });
    }

    if (desktopSearchInput) {
      desktopSearchInput.addEventListener('focus', function () {
        if (window.OdditSearchDrawer) {
          window.OdditSearchDrawer.open();
          this.blur();
        }
      });
    }
  }

  /* ------------------------------------------------------------
     Search Drawer — hide the header while open (desktop)
     The search overlay renders below the announcement bar in place of
     the header; the announcement bar stays visible. CSS gates this to
     desktop via `body.oddit-search-open`.
     ------------------------------------------------------------ */
  document.addEventListener('oddit:search-drawer:opened', function () {
    document.body.classList.add('oddit-search-open');
  });
  document.addEventListener('oddit:search-drawer:closed', function () {
    document.body.classList.remove('oddit-search-open');
  });

  /* ------------------------------------------------------------
     Live Cart Count Badge
     ------------------------------------------------------------ */
  function cartToggleLabel(count) {
    return 'Open cart, ' + count + ' ' + (count === 1 ? 'item' : 'items');
  }

  document.addEventListener('cart:updated', function (e) {
    if (!e.detail || !e.detail.cart) return;
    var cart = e.detail.cart;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
      badges[i].style.display = cart.item_count > 0 ? '' : 'none';
    }
    var toggles = document.querySelectorAll('[data-cart-toggle]');
    for (var j = 0; j < toggles.length; j++) {
      toggles[j].setAttribute('aria-label', cartToggleLabel(cart.item_count));
    }
  });

  /* ------------------------------------------------------------
     Init
     ------------------------------------------------------------ */
  function init() {
    var headers = document.querySelectorAll('.oddit-header');
    for (var i = 0; i < headers.length; i++) {
      initHeader(headers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();